import { z } from "zod";
import { feedQuerySchema } from "../post/feed-query.js";

export const COMMENT_SORT_VALUES = ["oldest", "top"] as const;

export const commentQuerySchema = feedQuerySchema.extend({
	sort: z.enum(COMMENT_SORT_VALUES).default("oldest"),
});

export type CommentQueryPayload = z.infer<typeof commentQuerySchema>;
